<template>
  <div class="columns is-multiline">
    <div class="column is-6">
      <section>
        <b-field label="Display name">
          <b-input
            v-model="formGeneral.name"
            required>
          </b-input>
        </b-field>
      </section>
    </div>

    <div class="column is-6">
      <b-field label="Check frequency">
        <b-select placeholder="Select the test type" expanded v-model="formGeneral.timeout" required>
          <option
            v-for="frequency in frequencies"
            :value="frequency.value"
            :key="frequency.value">
            {{ frequency.name }}
          </option>
        </b-select>
      </b-field>
    </div>

    <div class="column is-6">
      <b-field label="Status">
        <b-select placeholder="Select the test type" expanded v-model="formGeneral.status" required>
          <option
            v-for="status in statuses"
            :value="status.value"
            :key="status.value">
            {{ status.name }}
          </option>
        </b-select>
      </b-field>
    </div>
  </div>
</template>

<script>

export default {
  name: 'General',
  data () {
    return {
      formGeneral: {},
      frequencies: [
        {
          name: 'every minute',
          value: 60
        },
        {
          name: 'every 5 minutes',
          value: 300
        },
        {
          name: 'every 10 minutes',
          value: 600
        },
        {
          name: 'every 30 minutes',
          value: 1800
        },
        {
          name: 'hourly',
          value: 3600
        },
        {
          name: 'daily',
          value: 86400
        }
      ],
      statuses: [
        {
          name: 'Active',
          value: 'active'
        },
        {
          name: 'Disabled',
          value: 'disabled'
        }
      ]
    }
  },

  created() {
    this.formGeneral = this.$store.getters['testJob/formGeneral'];
  }
}
</script>
